import { memo, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";
import { canTrackingEmbeddedRoute } from "../utils";
var GoogleAnalyticsTrackingWrapper = function (_a) {
    var initialized = _a.initialized, children = _a.children, isRouteEmbedded = _a.isRouteEmbedded;
    var _b = useLocation(), pathname = _b.pathname, search = _b.search;
    var isLogin = pathname === "/login";
    var hasQueryParamsRoute = !!search;
    useEffect(function () {
        if (initialized && !isRouteEmbedded) {
            ReactGA.pageview(pathname + search);
        }
        if (initialized &&
            isRouteEmbedded &&
            canTrackingEmbeddedRoute(isLogin, hasQueryParamsRoute)) {
            ReactGA.pageview(pathname + search);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialized, pathname, search, isRouteEmbedded]);
    return children;
};
export default memo(GoogleAnalyticsTrackingWrapper);
